"use strict";
try {
    console.debug('Pro Gallery Version: 3.1.38');
    // eslint-disable-next-line no-empty
}
catch (e) { }
//# sourceMappingURL=versionLogger.js.map